import _ from 'lodash';
window._ = _;

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo, over Reverb.
 *
 * Reverb speaks the Pusher protocol, which is why the pusher-js client is here
 * without any Pusher account behind it.
 *
 * Deliberately optional: window.Echo stays undefined when VITE_REVERB_APP_KEY
 * is absent, and every subscriber checks for it. The app has run without
 * broadcasting since it was built, most screens do not need it, and a missing
 * key on one environment must not take the bundle down on that environment --
 * it should just mean no live updates there.
 */
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

const reverbKey = import.meta.env.VITE_REVERB_APP_KEY;

if (reverbKey) {
    window.Echo = new Echo({
        broadcaster: 'reverb',
        key: reverbKey,
        wsHost: import.meta.env.VITE_REVERB_HOST ?? window.location.hostname,
        wsPort: Number(import.meta.env.VITE_REVERB_PORT ?? 80),
        wssPort: Number(import.meta.env.VITE_REVERB_PORT ?? 443),
        // The app is served over https in production, where a browser refuses a
        // plain ws:// socket as mixed content. That makes the scheme a
        // deployment fact, not a preference: wss needs a proxy in front of
        // Reverb, which listens on plain http.
        forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? 'https') === 'https',
        enabledTransports: ['ws', 'wss'],
    });
}
